import { Card, CardContent } from "../../../../../../components/ui/card";

export const VisualInspectionTab: React.FC = () => {
  return (
    <Card>
      <CardContent className="p-6">
        <h3 className="text-lg font-medium">Visual Inspection</h3>
        {/* Visual inspection content will be added here */}
      </CardContent>
    </Card>
  );
}; 